import { Dictionary } from '@shared/dictionary';

const MAX_IMAGE_SIZE_MB = 10;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
const MAX_VIDEO_SIZE_MB = 50;
const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

const PET_NAME_MAX_CHARS = 15;

export const fileSizeValidator = (file: File) => {
  if (file.type.startsWith('image/')) {
    return file.size <= MAX_IMAGE_SIZE_BYTES;
  } else if (file.type.startsWith('video/')) {
    return file.size <= MAX_VIDEO_SIZE_BYTES;
  }
  return true;
};

export const validatePetName = (value: string, dictionary: Dictionary) => {
  const finalValue = value.trim();

  if (finalValue.length === 0) {
    return dictionary.forms.validations.onlySpaces;
  }

  if (finalValue.length > PET_NAME_MAX_CHARS) {
    return dictionary.forms.tributes.petNameToLong;
  }

  // TODO: Implement pet name validation logic
  // no number only names, no special character only names, etc.
  return true;
};

export const validateIfPromoCodeIsValid = async (promotionCode: string | undefined, validatePromo: any, dictionary: Dictionary) => {
  if (!promotionCode) {
    return true;
  }
  try {
    const response = await validatePromo.mutateAsync({ promotion_code: promotionCode });
    if (!response?.promotion_code_valid) {
      return dictionary.tributes.checkout.validations.promotionCodeInvalid;
    }
    return true;
  } catch (error) {
    console.error('Error checking promotion code:', error);
    return dictionary.errors.somethingWentWrong;
  }
};

type ValidateDateArgs = {
  value?: CVT.MaybeNull<Date> | string,
  birthday?: CVT.MaybeNull<Date>,
  maxDate: Date,
  minDate: Date,
  dictionary: Dictionary,
}

export const validateBirthdayDate = ({
  value,
  maxDate,
  minDate,
  dictionary,
}: ValidateDateArgs) => {
  if (value && value < minDate) {
    return dictionary.forms.validations.dateTooOld;
  }
  if (value && value > maxDate) {
    return dictionary.forms.validations.dateInFuture;
  }
  return true;
};

export const validatePassingDate = ({
  value,
  maxDate,
  minDate,
  birthday,
  dictionary,
}: ValidateDateArgs) => {
  if (value && value < minDate) {
    return dictionary.forms.validations.dateTooOld;
  }
  if (value && value > maxDate) {
    return dictionary.forms.validations.dateInFuture;
  }
  if (value && birthday && value < birthday) {
    return dictionary.forms.validations.passingAfterBirth;
  }
  return true;
};
